import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import NovaRootsWay from "./pages/NovaRootsWay";
import LearningModel from "./pages/LearningModel";
import LivingCurriculum from "./pages/LivingCurriculum";
import Environment from "./pages/Environment";
import Walezi from "./pages/Walezi";
import NairobiPilot from "./pages/NairobiPilot";
import Admissions from "./pages/Admissions";
import Fees from "./pages/Fees";
import Founder from "./pages/Founder";
import Contact from "./pages/Contact";
import ContactSubmissions from "./pages/ContactSubmissions";
import FaithLearning from "./pages/FaithLearning";
import LivingCultures from "./pages/LivingCultures";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nova-roots-way" element={<NovaRootsWay />} />
            <Route path="/learning-model" element={<LearningModel />} />
            <Route path="/living-curriculum" element={<LivingCurriculum />} />
            <Route path="/environment" element={<Environment />} />
            <Route path="/walezi" element={<Walezi />} />
            <Route path="/nairobi-pilot" element={<NairobiPilot />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/faith-learning" element={<FaithLearning />} />
            <Route path="/living-cultures" element={<LivingCultures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/submissions" element={<ContactSubmissions />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
